/* eslint-disable no-nested-ternary */
import React from 'react';
import ArrowButton from './button-arrow';

const Button = ({
  children, submit, inline, hidden, ...props
}) => (
  <div style={{display: (hidden ? 'none' : (inline ? 'inline-block' : 'block'))}}>
    <ArrowButton
      arrow={false}
      submit={submit}
      {...props}
    >
      {children}
    </ArrowButton>
  </div>
);

Button.defaultProps = {
  submit: false,
  hidden: false,
  inline: false,
};

export default Button;




// WEBPACK FOOTER //
// ./src/components/common/button.jsx